import LiquidityRunway from './LiquidityRunway';
import EstateTax from './EstateTax';
import ModulePlaceholder from '../components/common/ModulePlaceholder';

export function LiquidityRunwayPage() {
  return <LiquidityRunway />;
}

export function CapitalStructurePage() {
  return (
    <ModulePlaceholder
      title="Capital Structure"
      description="Leverage analysis with LTV and DSCR tracking across all entities. Model contribution scenarios, monitor covenant compliance, and stress-test your debt stack."
      phase={3}
    />
  );
}

export function EstateTaxPage() { return <EstateTax />; }

export function StrategyWorkbenchPage() {
  return (
    <ModulePlaceholder
      title="Strategy Workbench"
      description="Model GRATs, IDGTs, ILITs, annual gifting programs, and combine strategies to see interaction effects. The combination engine shows how strategies work together — or conflict."
      phase={5}
    />
  );
}

export function GiftTrackerPage() {
  return (
    <ModulePlaceholder
      title="Gift & GST Tracker"
      description="Unified credit tracking across all donors, anti-clawback analysis, and exemption scenario modeling. Track Form 709 filings and remaining exemption in real time."
      phase={6}
    />
  );
}

export function EntityModelerPage() {
  return (
    <ModulePlaceholder
      title="Entity Modeler"
      description="Contributions, redemptions, entity freezes, §2701 compliance checking, and buy-sell agreement modeling. Full lifecycle tracking for every trust, LLC, and partnership."
      phase={6}
    />
  );
}

export function TimingOverlayPage() {
  return (
    <ModulePlaceholder
      title="Timing Overlay"
      description="Death-at-year-N simulations across all modules. See how estate tax liability, strategy effectiveness, and liquidity position change based on when a mortality event occurs."
      phase={7}
    />
  );
}
